<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>{{ header }}</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="copy(state.ca1)" v-if="state.ca1 !=''">
                Copy C/A 1 Link
            </span>
            <span class="pgebtn" @click="copy(state.ca2)" v-if="state.ca2 !=''">
                Copy C/A 2 Link
            </span>
            <span class="pgebtn" @click="copy(state.exam)" v-if="state.exam !=''">
                Copy Exam Link
            </span>
            <span class="pgebtn" @click="copy(state.semester)">
                Copy Link
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="subject" header="Subject" />
        <PrimeColumn field="score" header="Scores" />
        <PrimeColumn field="final" header="Final Score" />
        <PrimeColumn field="grade" header="Grade" />
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRouter, useRoute } from "vue-router";

export default {
    name:"AcademicResults",
    setup(){
        const route = useRoute();
        const router = useRouter();
        const id = computed(() => route.params.id)
        const semester = computed(() => route.query.s)
        const state=reactive({loading:true, ca1:"",ca2:"",exam:"",semester:""})
        const list = ref([])
        const globalFilter=ref("")
        const header=ref("Semester Result");
        header.value=semester.value+" Semester Result";
        
        //year=2&stu=8&s=Fall
        onMounted(() => {
            var r=route.query,
            data={
                getResults:r.year,
                stu:r.stu,
                s:r.s
            }
            call({
                url:urls.academic,
                data:data,
                success:(res)=>{
                state.loading=false
                if(res.status){
                    if (!Array.isArray(res.msg)) {
                        list.value = Object.values(res.msg.list)
                    } else {
                        list.value = res.msg.list
                    }
                    state.ca1=res.msg.ca1;
                    state.ca2=res.msg.ca2;
                    state.exam=res.msg.exam;
                    state.semester=res.msg.sem_link;
                }else{
                    alert(res.msg);
                }
                }
            })
        });

        function action(row,type){
            console.log(type,id)
            router.push({ name: 'academicresult', params: { id: row.id } });
        }

        function copy(text) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    alert("Link copied to clipboard!");
                })
                .catch(err => {
                    alert("Error copying link: ", err);
                });
        }
        
        return {copy,list,globalFilter, state,action, header}
    }
}
</script>